module.exports = __webpack_public_path__ + "img/b-a.d2a64465.png";